import React, { useCallback, useState } from "react";
import { Button, DetailDrawer, InnoTable } from "InnoUI/components";
import SC from "./style";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import JournalDetails from "views/ProjectHome/Journal/JournalDetails";
import TimezoneConverter from "components/TimeZoneConvertor";
import { projectType } from "utils/lookUpTable";
import theme from "@theme/";
import { tenantReleaseStatus } from "utils/optionData/utils";

const OccupantTable = (props) => {
  const {
    popupState,
    data,
    pageSize,
    currentPage,
    setCurrentPage = () => {},
    setPageSize = () => {},
    isLoading = false,
  } = props;
  // const [data, setData] = useState(data);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const occupantId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [filters, setFilters] = useState({
    requestType: null,
    searchValue: null,
    propertyIds: null,
    roles: null,
  });

  const handlePagination = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
  };

  const onRowClick = useCallback(() => {}, []);

  const onAddDataCallback = () => {
    navigate(`/journal/add-journal?projectId=${occupantId}&type=${type}`);
  };

  const handleJournalClick = (record) => {
    // console.log(record, "record");

    navigate(
      `/project-home/occupanthomepage?projectId=${record.id}&type=${projectType.occupant}`,
    );
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  const occupantColumns = [
    {
      title: "Occupant No.",
      dataIndex: "occupantNo",
      width: 150,

      render(value, record) {
        return <p>{value}</p>;
      },
    },
    {
      title: "Occupant Name",
      dataIndex: "occupantName",
      width: 150,

      render(value, record) {
        return <p>{value}</p>;
      },
    },
    {
      title: "Active Journals",
      dataIndex: "journalActive",
      width: 150,

      render(value, record) {
        return <p>{value}</p>;
      },
    },
    {
      title: "Closed Journals",
      dataIndex: "journalClosed",
      width: 150,

      render(value, record) {
        return <p>{value}</p>;
      },
    },
    {
      title: "Occupants Area",
      dataIndex: "occupantArea",
      width: 150,

      render(value, record) {
        return (
          <p>
            {value} {record?.areaUnit}
          </p>
        );
      },
    },
    {
      title: "Outstanding Issue",
      dataIndex: "outstandingCount",
      width: 150,
      render(value, record) {
        return <p>{value}</p>;
      },
    },
    {
      title: "Tenants Status",
      dataIndex: "tenantStatus",
      width: 150,
      render(value, record) {
        const tenantStatus = tenantReleaseStatus.find(
          (item) => item.id === value,
        );
        return <p>{tenantStatus?.label}</p>;
      },
    },
    {
      title: "Primary Contacts",
      dataIndex: "outstandingCount",
      width: 150,
      render(value, record) {
        const primaryContactAllName = record?.primaryContact?.map(
          (contact) => contact.fullName,
        );
        return <p>{primaryContactAllName.join(", ") || ""}</p>;
      },
    },

    {
      title: "Created On",
      dataIndex: "createOn",
      render(value, record) {
        return (
          <span
            style={{
              color: theme.colors.modernGray[600],
              fontWeight: 500,
            }}
          >
            <TimezoneConverter time={value} />
          </span>
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",
      render(value, record) {
        return (
          <Button
            caption={"View"}
            onClick={() => handleJournalClick(record)}
            color="white"
            fontSize="12px"
            style={{
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "50px",
              height: "28px",
              borderRadius: theme.modernTokens.borderRadius.md,
              textTransform: "normal",
              fontWeight: 600,
              border: "none",
              boxShadow: theme.modernTokens.shadows.sm,
              transition: theme.modernTokens.transitions.normal,
            }}
          />
        );
      },
    },
  ];

  const onFilterChange = (data) => {
    const { requestType, propertyName, roles } = data;
    setFilters({
      ...filters,
      requestType: requestType,
      propertyIds: propertyName,
      roles: roles,
    });
  };

  const tableConfig = {
    sno: true,
    draggable: false,
    selection: false,
    expandable: false,
    pagination: {
      position: ["topRight", "bottomRight"],
      current: currentPage,
      defaultCurrent: currentPage,
      pageSize: pageSize,
      total: data?.totalCount || 0,
      onChange: (page, pageSize) => {
        handlePagination(page, pageSize);
      },
      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      itemRender: (_, type, originalElement) => {
        if (type === "prev") {
          return <a>Previous</a>;
        }
        if (type === "next") {
          return <a>Next</a>;
        }
        return originalElement;
      },
    },
    addNew: false,
    search: false,
    action: false,
    divBorder: false,
  };

  return (
    <div style={{ marginBottom: "24px" }}>
      <SC.CardContainerStyle>
        <InnoTable
          tableConfig={tableConfig}
          loading={isLoading}
          padding="16px"
          column={occupantColumns}
          data={data?.data || []}
          // tableKey="Journal"
          searchKeys={["subject", "roles", "sendTo"]}
          selectedItems={[]}
          onAddDataCallback={onAddDataCallback}
          onFilterChange={onFilterChange}
          onRowClick={onRowClick}
        />
      </SC.CardContainerStyle>

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          closable={true}
          width={"865px"}
          children={
            <JournalDetails
              onClose={closeDrawer}
              selectedRowId={selectedRow}
              fetchData={""}
            />
          }
        ></DetailDrawer>
      )}
    </div>
  );
};

export default OccupantTable;
